import { compareAsc } from 'date-fns'
import { customizeError, formatDate } from '@chilecompra/react-kit'
import { makeActionCreator } from '../../config/store/utils'
import { checkIfForeignDni } from '../../modules/utils/helpers'
import { onGetLegalSuitabilityThunk } from '../LegalSuitabilitySection/LegalSuitabilitySection.actions'
import { onGetSiiInformationThunk } from '../SiiInformationSection/SiiInformationSection.actions'

export const GET_TECHNICAL_SUITABILITY = 'GET_TECHNICAL_SUITABILITY'
export const GET_TECHNICAL_SUITABILITY_ERROR = 'GET_TECHNICAL_SUITABILITY_ERROR'
export const GET_TECHNICAL_SUITABILITY_SUCCESS = 'GET_TECHNICAL_SUITABILITY_SUCCESS'
export const onGetTechnicalSuitability = makeActionCreator(GET_TECHNICAL_SUITABILITY)
export const onGetTechnicalSuitabilityError = makeActionCreator(GET_TECHNICAL_SUITABILITY_ERROR, 'payload')
export const onGetTechnicalSuitabilitySuccess = makeActionCreator(GET_TECHNICAL_SUITABILITY_SUCCESS, 'payload')
export const onGetTechnicalSuitabilityThunk = payload => async (dispatch, getState) => {
  dispatch(onGetTechnicalSuitability())

  try {
    const { sellerType } = getState().basicSellerInformation
    const { dni } = getState().siiInformation
    const isForeign = checkIfForeignDni(payload.dni)

    if (!isForeign && dni !== payload.dni) {
      dispatch(onGetSiiInformationThunk({ dni: payload.dni }))
    }

    return sellerType === 'natural'
      ? dispatch(onGetTechnicalSuitabilityForNaturalThunk({ dni: payload.dni }))
      : dispatch(onGetTechnicalSuitabilityForLegalThunk({ dni: payload.dni }))
  } catch (error) {
    return dispatch(
      onGetTechnicalSuitabilityError({
        error: customizeError({
          originalError: error?.originalError,
          code: error?.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}
export const onGetTechnicalSuitabilityForNaturalThunk = payload => async (dispatch, getState) => {
  try {
    const { creationDate, dni } = getState().legalSuitability

    if (dni !== payload.dni) {
      return dispatch(
        onGetLegalSuitabilityThunk({
          dni: payload.dni,
          callback: () => dispatch(onGetTechnicalSuitabilityForNaturalThunk({ dni: payload.dni }))
        })
      )
    }

    return dispatch(
      onGetTechnicalSuitabilitySuccess({
        activityStartDate: creationDate === undefined ? 'Sin información' : formatDate(creationDate, 'dd-MM-yyyy')
      })
    )
  } catch (error) {
    return dispatch(
      onGetTechnicalSuitabilityError({
        error: customizeError({
          originalError: error?.originalError,
          code: error?.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}
export const onGetTechnicalSuitabilityForLegalThunk = payload => async (dispatch, getState) => {
  try {
    const { businessActivities, dni } = getState().siiInformation

    if (dni !== payload.dni) {
      return dispatch(
        onGetSiiInformationThunk({
          dni: payload.dni,
          callback: () => dispatch(onGetTechnicalSuitabilityForLegalThunk({ dni: payload.dni }))
        })
      )
    }
    const activityStartDate = [...businessActivities].sort((item1, item2) =>
      compareAsc(item1.startDate, item2.startDate)
    )[0]?.startDate
    return dispatch(
      onGetTechnicalSuitabilitySuccess({
        activityStartDate:
          activityStartDate === undefined ? 'Sin información' : formatDate(activityStartDate, 'dd-MM-yyyy')
      })
    )
  } catch (error) {
    return dispatch(
      onGetTechnicalSuitabilityError({
        error: customizeError({
          originalError: error?.originalError,
          code: error?.code,
          reason: 'SOMETHING_WENT_WRONG_ERROR'
        }).toObject()
      })
    )
  }
}
